class JobPopup extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.init();
    this.checkForSubmittedForm();
  }

  init() {
    this.triggerButtons = document.querySelectorAll('[data-job-popup-button]');
    if (this.triggerButtons.length > 0) {
      this.triggerButtons.forEach((button) => {
        button.addEventListener('click', () => this.openPopup());
      });
    } else {
      console.warn('JobPopup: trigger button not found');
    }

    if (this.dialog) {
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          this.closePopup();
        }
      });

      this.dialog.addEventListener('close', () => this.closePopup());
    }
  }

  openPopup() {
    this.dialog?.showModal();
  }

  closePopup() {
    this.dialog?.close();
  }

  checkForSubmittedForm() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('contact_posted') === 'true' && window.location.hash === '#JobForm') {
      this.openPopup();
    }
  }
}

customElements.define('job-popup', JobPopup);
